import React, { useRef, useState, useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import Vimeo from "@vimeo/player";
import YouTube from "react-youtube";
import Dailymotion from "react-dailymotion";
import "video.js";
import VideoThumbnail from "react-video-thumbnail";

export const VideoModule = observer(({settings, setAspectRatio}) => {
  useEffect(()=> {
    setAspectRatio("16 / 9")
  },[])
  const [forceThumbnail,setForceThumbnail] = useState()
  const { style = {}, hidden} = settings;
  if(hidden) return null;
  return <div style={{ ...style, position: "relative", width: "100%", height: "100%" }}>
    <GenericPlayer {...settings} />
    {(!settings.thumbnail && settings.source) &&  <VideoThumbnail
    cors={true}
        videoUrl={settings.source}
        thumbnailHandler={(thumbnail) => {
          if (forceThumbnail !== thumbnail)
          setForceThumbnail(thumbnail)
        }}
        width={0}
        height={0}
        style={{ display: "none" }}
      />}
  </div> 
});



export const GenericPlayer = observer((settings) => {
  const url = settings.source;
  const thumbnail = settings.thumbnail;

  if (!url) return <VideoPlayer  url={''} thumbnail={thumbnail} />;
  else if (url.includes("vimeo")) return <VimeoPlayer url={url} />;
  else if (url.includes("youtube") || url.includes('youtu.be'))
    return (
      <div className="embeded-frame">
        <YouTubePlayer url={url}  />
      </div>
    );
  else if (url.includes("dailymotion") || url.includes("https://dai.ly/"))
    return (
      <div className="embeded-frame">
        <DailyMotionPlayer  url={url}  />
      </div>
    );
  else if (url.includes("jirango")) {
    return (
      <VideoPlayer  url={url} />
    );
  } 
  else{
    if(thumbnail.includes('http')){
      return  <VideoPlayer  url={url} thumbnail={thumbnail} />
    }
    return (
   
      <iframe
         title="Player"
        frameBorder="0"
        scrolling="0"
        allowFullScreen
        allow="autoplay; fullscreen"
        style={{ width: "100%", height: "100%", border: "0px" }}
        src={url}
      />
    );}
});
const VimeoPlayer = ({ url,thumbnail }) => {
  const [played, setPlayed] = useState(false);
  const [videoId, setVideoId] = useState(null);
  const iframeRef = useRef(null);
  const playedRef = useRef();
  const playerUrl = `https://player.vimeo.com/video/${videoId}`
  const extractIdFromUrl = () => {
    if (/vimeo.com\/(\d+)/i.test(url)) {
      setVideoId(/vimeo.com\/(\d+)/i.exec(url)[1]);
    } else if (/player.vimeo.com\/video\/(\d+)/i.test(url)) {
      setVideoId(/player.vimeo.com\/video\/(\d+)/i.exec(url)[1]);
    }
  };
  useEffect(() => {
    extractIdFromUrl();
  }, [url]);
  useEffect(()=> {
    playedRef.current = played;
  },[played])
  useEffect(() => {
    const player = new Vimeo(iframeRef.current);
    player.on("play", function () {
      if (playedRef.current) return;
      setPlayed(true);
    });
    return () => {
      iframeRef.current = null;
    };
  }, []);
  return <iframe allowFullScreen={true} style={{ width: "100%", height: "100%", border: "0px" }} allow="autoplay; fullscreen; picture-in-picture" ref={iframeRef} src={playerUrl} />;
};

const YouTubePlayer = ({url}) => {
  const [played, setPlayed] = useState(false);
  const onPlay = () => {
    if (played) return;
    setPlayed(true);
  };
  const extractIdFromUrl = () => {
    let startString = "";
    if (url.includes("https://www.youtube.com/watch?v=")) {
      startString = "https://www.youtube.com/watch?v=";
      var tempString = url.replace(startString, "");

      return tempString.substring(0, tempString.includes("?") ? tempString.indexOf("?") : tempString.length);
    } else if (url.includes("https://youtu.be/")) {
      startString = "https://youtu.be/";
      var tempString = url.replace(startString, "");
      return tempString.substring(0, tempString.includes("?") ? tempString.indexOf("?") : tempString.length);
    } else if (url.includes("https://www.youtube.com/embed/")) {
      startString = "https://www.youtube.com/embed/";
      var tempString = url.replace(startString, "");

      return tempString.substring(0, tempString.includes("?") ? tempString.indexOf("?") : tempString.length);
    }
  };

  const id = useMemo(() => {
    return extractIdFromUrl();
  }, [url]);

  const opts = {
    height: "100%",
    width: "100%",
    playerVars: {
      autoplay: url.toString().includes("autoplay=1") ? 1 : 0,
    },
  };

  return <YouTube videoId={id} className="yt-video" opts={opts} onPlay={onPlay} />;
};

const DailyMotionPlayer = ({ url, thumbnail}) => {
  const [played, setPlayed] = useState(false);
  const extractIdFromUrl = () => {
    let startString = "";

    try {
      if (url.includes("https://dai.ly/")) {
        startString = "https://dai.ly/";
        var tempString = url.replace(startString, "");

        return tempString.substring(
          0,
          tempString.includes("?") ? tempString.indexOf("?") : tempString.length
        );
      } else if (url.includes("https://www.dailymotion.com/video/")) {
        startString = "https://www.dailymotion.com/video/";
        var tempString = url.replace(startString, "");

        return tempString.substring(
          0,
          tempString.includes("?") ? tempString.indexOf("?") : tempString.length
        );
      }
    } catch (error) {
      if (!url) return "";
    }
  };

  const onPlay = () => {
    if (played) return;
    setPlayed(true);
  };

  const id = useMemo(() => {
    return extractIdFromUrl();
  }, [url]);
  return <Dailymotion video={id} onPlay={onPlay} uiTheme="light"  />;
};

const VideoPlayer = ({ url,thumbnail, downloadable }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        backgroundColor: "#000",
      }}
    >
      <video
        // id={"jirango-vod-" + clientKey}
        className="video-js"
        controls
        preload="auto"
        style={{ width: "100%", height: "100%" }}
        poster={thumbnail}
        controlsList="nodownload"
        data-setup="{}"
      >
        <source src={url} type="video/mp4" />
        <source src={url} type="video/webm" />
        <p className="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a href="https://videojs.com/html5-video-support/" target="_blank">
            supports HTML5 video
          </a>
        </p>
      </video>
    </div>
  );
}